import React from 'react'
import { Avatar } from '@ztechapps/webui.util'

type ProductAvatarProps = {
  name: string
  coverImage: string
  coverImageThumb?: string
  size?: number
}
export const ProductAvatar = ({ name, coverImage, coverImageThumb, size = 40 }: ProductAvatarProps) => {
  const finalImage = coverImageThumb ?? coverImage

  return <Avatar name={name} src={finalImage} size={size} />
}
